/**
 * Created by yihong on 5/4/18.
 */
import {on, off} from './dom'
let lockCount = 0;

//锁住页面
export function lock() {
  on(document, 'touchstart', e => {
  });
  on(document, 'touchmove', e => {
  });
  if (!lockCount) {
    document.body.classList.add('act-overflow-hidden');
  }
  lockCount++;
}

//解除锁定
export function unlock() {
  lockCount--;
  off(document, 'touchstart', e => {
  });
  off(document, 'touchmove', e => {
  });
  if (!lockCount) {
    document.body.classList.remove('act-overflow-hidden');
  }
}



// WEBPACK FOOTER //
// ./src/tools/lockScroll.js